import styled from '@emotion/styled'

interface DisclaimerProps {
  disclaimer: string
}

const DisclaimerStyles = styled.div({
  padding: '1rem',
  borderRadius: 'var(--radii-default)',
  border: '1px solid rgb(255, 143, 28)',
  backgroundColor: 'rgba(255, 143, 28, 0.08)',
  marginBottom: '2rem',

  '& p:not(:last-child)': {
    marginBottom: '1rem',
  },
})

export const Disclaimer = ({ disclaimer }: DisclaimerProps) => (
  <DisclaimerStyles dangerouslySetInnerHTML={{ __html: disclaimer }} />
)
